// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.filter-input input {\n  font-size: var(--fs-input) !important;\n  color: var(--green) !important;\n  font-weight: 400 !important;\n  padding-top: 9px !important;\n  padding-bottom: 9px !important;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
